/* eslint-disable max-len */
import { FoldersTranslations } from '../interfaces/folders';

const EnglishFoldersTranslations: FoldersTranslations = {
  toolbar: {
    expandAll: 'Expand all',
    collapseAll: 'Collapse all',
    newFolder: 'New folder',
    newList: 'New list',
    cancelSelection: 'Cancel selection',
    deleteMany: 'Delete several',
    bulkModeTooltip: 'Multiple selection mode',
    search: 'Search',
  },
  tree: {
    loading: 'Loading the folder structure...',
    noResults: 'No results for "{{query}}"',
    clearSearch: 'Clear search',
    subfolders: 'Subfolders: {{n}}',
    listsCount: 'Number of lists (including subfolders)',
    createdAt: 'Created on',
    wordsCount: 'Number of words',
  },
  menu: {
    newSubfolder: 'New subfolder',
    newList: 'New list',
    rename: 'Rename',
    move: 'Move',
    share: 'Share',
    edit: 'Edit',
    duplicate: 'Duplicate',
  },
  createFolder: {
    title: 'New folder',
    titleSub: 'New subfolder',
    placeholder: 'Folder name',
  },
  createList: {
    title: 'New list',
    titleInFolder: 'New list in the folder',
    name: 'name',
    description: 'description',
    inFolderInfo: 'The list will be created in the selected folder',
  },
  move: {
    moveFolder: 'Move the folder:',
    moveList: 'Move the list:',
    duplicateFolder: 'Duplicate the folder:',
    duplicateList: 'Duplicate the list:',
    chooseTarget: 'Choose the target folder:',
    chooseForCopy: 'Choose a folder for the copy:',
    search: 'Search for a folder…',
    root: 'Main folder',
    move: 'Move',
    duplicate: 'Duplicate',
  },
  delete: {
    folderTitle: 'Delete folder',
    listTitle: 'Delete list',
    listConfirm: 'Are you sure you want to delete the list "{{name}}"?',
    folderConfirm: 'Are you sure you want to delete the folder "{{name}}"?',
    folderWithChildren: 'The folder "{{name}}" contains {{n}} items...',
    bulkTitle: 'Delete {{n}} items',
    bulkConfirm: 'Are you sure you want to delete the selected items?',
    tooManyTitle: 'Too many items',
    tooManyContent: 'You can delete at most {{max}} items at once.',
  },
  validation: {
    nameEmpty: 'The name cannot be empty',
    nameTooLong: 'The name is too long (max {{max}} characters)',
    nameInvalid: 'The name contains characters that are not allowed',
  },
  messages: {
    maxNesting: 'At most {{max}} nesting levels',
    nestingTitle: 'Nesting limit exceeded',
    nestingContent: 'The maximum allowed number of levels is {{max}}.',
    folderMoved: 'The folder has been moved',
    listMoved: 'The list has been moved',
    moveError: 'Error while moving',
    deleteError: 'Error while deleting',
    createFolderError: 'Error while creating the folder',
    listCreated: 'The list has been created',
    createListError: 'Could not create the list',
    listDataNotFound: 'List data not found',
    duplicateError: 'Error while duplicating',
    copySaved: 'The copy of the list has been saved',
    copyNotMoved: 'The copy was created but could not be moved — it is in the original’s folder',
    nothingSelected: 'No items selected',
    itemsDeleted: 'The items have been deleted',
    bulkDeleteError: 'An error occurred while deleting',
    cannotMoveIntoList: 'An item cannot be moved into a list',
    cannotMoveIntoItself: 'An item cannot be moved into itself',
    cannotMoveIntoSubfolder: 'A folder cannot be moved into its own subfolder',
    listTooShort: 'The list must contain at least 2 words',
    listLoadError: 'Could not load the list',
    listActivated: 'List activated — its data will be loaded',
    treeLoadError: 'Could not load the folder structure',
    folderCreated: 'The folder has been created',
    folderRenamed: 'The folder has been renamed',
    listRenamed: 'The list has been renamed',
    renameError: 'Could not rename',
    folderDeleted: 'The folder has been deleted',
    folderDeleteError: 'Could not delete the folder',
    itemMoveError: 'Could not move the item',
    itemsDeleteError: 'Error while deleting items',
    itemNotDeleted: 'Could not delete an item',
    folderLoadError: 'Could not load the folder contents',
  },
};

export default EnglishFoldersTranslations;
